import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { map, pipe } from 'rxjs';

// AngularFire AuthGuard Services
import {
  AngularFireAuthGuard,
  customClaims,
} from '@angular/fire/compat/auth-guard';

const hasCustomToken = (data: any) => {
  return pipe(
    customClaims,
    map((claims) => {
      const redirectTo =
        data.queryParams && !!data.queryParams.identifier
          ? ['auth/login', { redirectTo: data['_routerState']['url'] }]
          : 'auth/login';
      return claims.tenant ? true : redirectTo;
    })
  );
};

const redirectLoggedInToHome = () =>
  pipe(
    customClaims,
    map((claims) => (claims.tenant ? ['pages'] : true))
  );

const routes: Routes = [
  // redirect without the / to keep query params after redirect
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
    loadChildren: () => import('@noovle/auth').then((m) => m.AuthModule),
  },
  {
    path: 'pages',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: hasCustomToken, isPublic: false },
    loadChildren: () =>
      import('./page-viewer/page-viewer.module').then(
        (m) => m.PageViewerModule
      ),
  },
  {
    path: 'public/pages',
    data: { isPublic: true },
    loadChildren: () =>
      import('./page-viewer/page-viewer.module').then(
        (m) => m.PageViewerModule
      ),
  },
  {
    path: 'dashboard',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: hasCustomToken, isPublic: false },
    loadChildren: () =>
      import('./page-viewer/page-viewer.module').then(
        (m) => m.PageViewerModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
